import { graphql } from '@client/graphql/types';
import { useMutation } from '@apollo/client';

const MUTATION = graphql(`
  mutation DeleteStripeApi($id: String!) {
    deleteStripeAPIKey(id: $id)
  }
`);

export default function useDeleteStripeApi() {
  return useMutation(MUTATION, { refetchQueries: ['StripeAPIKeys'] });
}
